import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icon";
import Pill from "../ui/Pill";
import {
  coordinatorName,
  projectSituationPill,
  projectStatusLabel,
  projectStatusPill,
  projectTypeLabel,
  projectTypePill,
} from "../../domain/projects";
import { formatFullDate, formatRelativeDate } from "../../lib/formatDate";
import { paths } from "../../routes/paths";

function ProjectRow({ project, onNavigate }) {
  const coordinator = coordinatorName(project);
  const status = projectStatusLabel(project.projectStatus);
  const situation = project.situation;
  const updatedAt = formatRelativeDate(project.updated_on);

  return (
    <tr>
      <td>
        <div className="row-title">
          <Link
            className="row-link row-link-block"
            to={paths.sprints(project.id)}
            state={{ projectName: project.name }}
            onClick={() => onNavigate?.(project)}
          >
            {project.name}
          </Link>
        </div>
        {/* {project.identifier && <div className="row-meta">{project.identifier}</div>} */}
      </td>

      <td className="col-type">
        <Pill variant={projectTypePill(project.projectType)}>
          {projectTypeLabel(project.projectType)}
        </Pill>
      </td>

      <td className={situation ? "col-situation" : "cell-empty col-situation"}>
        {situation ? <Pill variant={projectSituationPill(situation)}>{situation}</Pill> : "—"}
      </td>

      <td className={status ? "col-status" : "cell-empty col-status"}>
        {status ? <Pill variant={projectStatusPill(project.projectStatus)}>{status}</Pill> : "—"}
      </td>

      <td
        className={coordinator ? "cell-txt col-coordinator" : "cell-txt cell-empty col-coordinator"}
      >
        {coordinator || "—"}
      </td>

      <td className="cell-muted col-upd" title={formatFullDate(project.updated_on) || undefined}>
        {updatedAt || "—"}
      </td>

      <td className="col-go">
        <div className="go">
          <Icon name="chevron-right" />
        </div>
      </td>
    </tr>
  );
}

export default ProjectRow;
